import { trlMessage } from '@/services/i18n';
import { getLocalStorageItem, LOGIN_THEME_EVENT_ID_STORAGE_KEY, removeLocalStorageItem, setLocalStorageItem } from '@/utils/local-storage';
const communityArtwork = new URL('./assets/community-faces.png', import.meta.url).href;
const communityOverlayArtwork = new URL('./assets/community-lines.svg', import.meta.url).href;
const naemArtwork = new URL('./assets/naem-cover.svg', import.meta.url).href;
const naemMobileArtwork = new URL('./assets/line.svg', import.meta.url).href;
const NAEM_EVENT_ID = 'bb093f0f4f5b4240b9761aa5332922fc';
const EVENT_REDIRECT_PATTERN = /^\/events\/([^/?#]+)\/buy\/\d+(?:[/?#]|$)/;
function createDefaultTheme() {
    return {
        variant: 'default',
        heroTitle: trlMessage('login.hero.title'),
        heroSubtitle: trlMessage('login.hero.subtitle'),
        heroArtwork: communityArtwork,
        heroOverlayArtwork: communityOverlayArtwork,
        phoneTitle: trlMessage('login.step.phone'),
        registrationTitle: trlMessage('login.step.registration')
    };
}
function createNaemTheme() {
    return {
        variant: 'event',
        heroLogo: 'naem',
        heroSubtitle: trlMessage('login.hero.naem.subtitle'),
        heroArtwork: naemArtwork,
        heroMobileArtwork: naemMobileArtwork,
        phoneTitle: trlMessage('login.step.naem.phone'),
        registrationTitle: trlMessage('login.step.registration')
    };
}
const eventThemes = {
    [NAEM_EVENT_ID]: createNaemTheme
};
export function getEventIdFromRedirect(redirect) {
    if (typeof redirect !== 'string') {
        return null;
    }
    const match = redirect.match(EVENT_REDIRECT_PATTERN);
    return match?.[1] ?? null;
}
export function getLoginTheme(redirect) {
    const eventId = getEventIdFromRedirect(redirect);
    if (eventId) {
        const eventTheme = eventThemes[eventId];
        if (!eventTheme) {
            return createDefaultTheme();
        }
        setLocalStorageItem(LOGIN_THEME_EVENT_ID_STORAGE_KEY, eventId);
        return eventTheme();
    }
    const storedEventId = getLocalStorageItem(LOGIN_THEME_EVENT_ID_STORAGE_KEY);
    if (!storedEventId) {
        return createDefaultTheme();
    }
    const storedTheme = eventThemes[storedEventId];
    if (!storedTheme) {
        removeLocalStorageItem(LOGIN_THEME_EVENT_ID_STORAGE_KEY);
        return createDefaultTheme();
    }
    return storedTheme();
}
